import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Input, message, Modal, Space } from 'antd';
import { PRODUCT } from '../../../../constants/define/translation';
import { btnActive } from '../../../../styles';
import {
  postUpdateProductRepository,
  ProductOrders,
} from '../../../../repository/mytm/shop-product/shopProductRepository';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { UserContext } from '../../../../repository/context/userContext';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';

interface ActionsColumnProps {
  record: ProductOrders;
  onRefresh: () => void;
  defaultValue: number;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PRODUCT);
  const { record, onRefresh, defaultValue } = props;
  const userContext = useContext(UserContext);
  const [loading, setLoading] = useState(false);

  const updateProduct = async (id: string, payload: any) => {
    setLoading(true);
    return postUpdateProductRepository(id, payload)
      .then(() => {
        onRefresh();
        message.success(t('message.updateProductSuccess'));
      })
      .catch(e => {
        message.error(e?.errorMessage || t('message.updateProductError'));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onUpdateMaxQty = (updateValue: { productId: string; maxQty: any }) => {
    const payload = {
      productId: updateValue.productId,
      maxQty: updateValue.maxQty,
    };
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.update')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateProduct(record.id, payload);
            })
            .catch((e: any) => {
              setLoading(false);
              onRefresh();
              message.error(e?.errorMessage || t('message.updateProductError'));
            });
        }
      },
      onCancel() {
        setMaxQty(defaultValue);
      },
    });
  };

  const [maxQty, setMaxQty] = useState(defaultValue);
  let timeout: any;
  useEffect(() => {
    timeout = setTimeout(() => {
      if (maxQty !== defaultValue) {
        onUpdateMaxQty({ productId: record.product_id, maxQty });
      }
    }, 3000);
    return () => clearTimeout(timeout);
  }, [maxQty]);
  const handleOnEdit = async (value: any) => {
    clearTimeout(timeout);
    const { valueAsNumber } = value.target;
    setMaxQty(valueAsNumber);
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Input onChange={handleOnEdit} type="number" min="1" step={1} disabled={loading} value={maxQty} />
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
